export default __webpack_public_path__ + "static/media/icon-castbox.24ae9fc3.svg";